import { container } from '../../di/configureContainer';
import AccessTokenInitializer from '../../utils/AccessTokenInitializer';
import CallbackTokenScopeInitializer from '../../utils/CallbackTokenScopeInitializer';
import DateTimeSource from '../../utils/DateTimeSource';
import StateInitializer from '../../utils/StateInitializer';
import TokenDecoder from '../../utils/TokenDecoder';
import TokenEncoder from '../../utils/TokenEncoder';
import ValidationTokenInitializer from '../../utils/ValidationTokenInitializer';
import AccessTokenStorage from './AccessTokenStorage';
import BankSelectService from './BankSelectService';
import ConfigurationService from './ConfigurationService';
import ConfigurationStorageService from './ConfigurationStorageService';
import ConnectionSummaryService from './ConnectionSummaryService';
import ConsentConnectionService from './ConsentConnectionService';
import ConsentInfoService from './ConsentInfoService';
import ConsentService from './ConsentService';
import ConsentStorage from './ConsentStorage';
import PaymentAccountConfirmationService from './PaymentAccountConfirmationService';
import ProviderService from './ProviderService';
import RecaptchaService from './RecaptchaService';
import ValidationTokenStorage from './ValidationTokenStorage';
import UserIdStorage from './UserIdStorage';
import ConnectApiService from './ConnectApi';
import AppStateStorage from './AppStateStorage';
import DomainTypes from '../../di/DomainTypes';
import ThirdPartyTypes from '../../di/ThirdPartyTypes';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import LocalStorageContainer from './LocalStorageContainer';

export const connectApi = container.get(ConnectApiService);
export const configurationService = container.get(ConfigurationService);
export const providerService = container.get(ProviderService);
export const configurationStorageService = container.get(ConfigurationStorageService);
export const bankSelectApi = container.get(BankSelectService);
export const consentService = container.get(ConsentService);
export const consentStorage = container.get(ConsentStorage);
export const recaptchaService = container.get(RecaptchaService);
export const consentConnectionService = container.get(ConsentConnectionService);
export const connectionSummaryService = container.get(ConnectionSummaryService);
export const consentInfoService = container.get(ConsentInfoService);
export const tokenEncoder = container.get(TokenEncoder);
export const dateSource = container.get(DateTimeSource);
export const accessTokenStorage = container.get(AccessTokenStorage);
export const userIdStorage = container.get(UserIdStorage);
export const stateInitializer = container.get(StateInitializer);
export const accessTokenInitializer = container.get(AccessTokenInitializer);
export const callbackTokenScopeInitializer = container.get(CallbackTokenScopeInitializer);
export const tokenDecoder = container.get(TokenDecoder);
export const validationTokenInitializer = container.get(ValidationTokenInitializer);
export const validationTokenStorage = container.get(ValidationTokenStorage);
export const paymentAccountConfirmationService = container.get(PaymentAccountConfirmationService);
export const appStateStorage = container.get(AppStateStorage);
export const localStorageContainer = container.get(LocalStorageContainer);
export const applicationInsights = container.get(ThirdPartyTypes.ApplicationInsights) as ApplicationInsights;
export const correlationId = container.get<string>(DomainTypes.CorrelationId);
